import { createSlice } from '@reduxjs/toolkit';

const categoryFilterSlice = createSlice({
    name: 'categoryFilter',
    initialState: {
        isLoading: true,
        isLoadingCL: true,
        isError: false,
        error: false,
        categoryTypes: [],
        categoryLevels: [],
    },
    reducers: {
        fetchcategoryTypeOption: (state, action) => {
            state.categoryTypes = action.payload;
            state.isLoading = false;
        },
        fetchcategoryTypeOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
        fetchcategoryLevelOption: (state, action) => {
            state.categoryLevels = action.payload;
            state.isLoadingCL = false;
        },
        fetchcategoryLevelOptionError: (state, action) => {
            state.isLoadingCL = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
    },
});

export const {
    fetchcategoryTypeOption,
    fetchcategoryTypeOptionError,
    fetchcategoryLevelOption,
    fetchcategoryLevelOptionError,
} = categoryFilterSlice.actions;

export default categoryFilterSlice.reducer;
